import { Component, inject, Input, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormGroup, ValidationErrors } from '@angular/forms';
import { SharedModule } from '@sbd-account-portal/app/shared/shared.module';
import { SharedComponentsModule } from '@sbd-doug-frontend/shared/lib/shared-components/shared-components.module';
import { CIPXQuoteRequestIntakeForm } from '../../../../intake-form.types';
import { isCIPXQuoteRequestIntakeFormStateBond, requiresCredit } from '../../../../intake-form.helpers';
import { CIPXQuoteRequestIntakeFormService } from '../../../../intake-form.service';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { isServiceEmail } from '@sbd-doug-frontend/shared/lib/public-validators';
import { CURRENT_USER_TOKEN } from '@sbd-doug-frontend/shared/lib/types/current-user';

@Component({
  standalone: true,
  imports: [SharedModule, SharedComponentsModule, NgxMaskDirective],
  selector: 'cipx-quote-request-intake-form-request-details-owners',
  templateUrl: 'owners.component.html',
  providers: [provideNgxMask()],
})
export class CIPXQuoteRequestIntakeFormRequestDetailsOwnersComponent
  implements OnInit {
  private _intakeFormService = inject(CIPXQuoteRequestIntakeFormService);
  private _currentUser = inject(CURRENT_USER_TOKEN);

  @Input() quoteRequestForm!: FormGroup<CIPXQuoteRequestIntakeForm>;

  requiresCredit = requiresCredit;
  isCIPXQuoteRequestIntakeFormStateBond = isCIPXQuoteRequestIntakeFormStateBond

  selectedStateBond = this._intakeFormService.selectedStateBond;

  ngOnInit() {
    this.owners.controls.forEach(control => {
      const emailControl = control.get('owner_email');
      if (emailControl) {
        if (isServiceEmail(emailControl.value)) {
          emailControl.setValue('');
        }
        // Add team member validator
        const currentValidators = emailControl.validator;
        emailControl.setValidators(currentValidators ? [currentValidators, this.teamMemberEmailValidator()] : [this.teamMemberEmailValidator()]);
        emailControl.updateValueAndValidity({ emitEvent: false });
      }
    });

    // Handle new owners being added
    this.owners.valueChanges.subscribe(() => {
      this.owners.controls.forEach(control => {
        const emailControl = control.get('owner_email');
        if (emailControl && !emailControl.hasValidator(this.teamMemberEmailValidator())) {
          const currentValidators = emailControl.validator;
          emailControl.setValidators(currentValidators ? [currentValidators, this.teamMemberEmailValidator()] : [this.teamMemberEmailValidator()]);
          emailControl.updateValueAndValidity({ emitEvent: false });
        }
      });
    });
  }

  teamMemberEmailValidator() {
    return (control: AbstractControl): ValidationErrors | null => {
      const email = control.value;
      if (!email) return null;

      const cu = this._currentUser?.current?.();
      const teamMembers = cu?.team_members || [];

      const isTeamMember = teamMembers.some((member) =>
        member.account_user_email?.toLowerCase() === email.toLowerCase()
      );

      return isTeamMember ? { teamMemberEmail: true } : null;
    };
  }

  getSectionTitle(): string {
    if (this.quoteRequestForm.controls.bondLookup.controls.company_type_id.value === 3) {
      return 'Bonded Individual';
    }

    return (
      'Business Owner' +
      ((this.quoteRequestForm.controls.requestDetails.controls.company_number_owners.value ?? 1) > 1 ? 's' : '')
    );
  }

  get requestDetailsGroup(): FormGroup {
    return this.quoteRequestForm.controls.requestDetails;
  }

  /**
   * Returns the owners FormArray.
   */
  get owners(): FormArray {
    return this.quoteRequestForm.controls.requestDetails.controls.owners as FormArray;
  }

  getOwnerGroup(index: number): FormGroup {
    return this.owners.at(index) as FormGroup;
  }

}
